import { axios } from '@Root/API'

export const searchStudents = params => {
	return axios.get('contact-find/students', { params })
}
